exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label{font-weight:500}.rate .rate-stars{display:inline-block;vertical-align:middle}.rate .rate-stars i{cursor:pointer;color:#f2c600}.rate .tag{margin-left:3em;background:#f2c600;color:#000;height:35px;line-height:35px;display:inline-block;padding:0 20px;position:relative;cursor:pointer}.rate .tag:before{position:absolute;top:0;left:-15px;content:\"\";width:0;height:0;border-style:solid;border-width:18px 15px 18px 0;border-color:transparent #f2c600 transparent transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fc49eca","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/rate.vue
// module id = fI9Z
// module chunks = 4